export const GA_DEFAULT_EVENT = 'GAevent'
export const GA_PROMOTION_CLICK = 'promotionClick'
export const GA_PROMOTION_IMPRESSION = 'promotionImpression'

export const SEGMENT_PROMOTION_CLICK = 'Promotion Clicked'
export const SEGMENT_PROMOTION_IMPRESSION = 'Promotion Viewed'
